import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toHourMinute'
})
export class ToHourMinutePipe implements PipeTransform {
  transform(value: number, fromMinutes: boolean = false): string {
    if (value == null || isNaN(value)) return '';
    let hours: number, minutes: number;
    if (fromMinutes) {
      hours = Math.floor(value / 60);
      minutes = Math.round(value % 60);
    } else {
      hours = Math.floor(value);
      minutes = Math.round((value - hours) * 60);
    }
    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}m`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else if (minutes > 0) {
      return `${minutes}m`;
    } else {
      return '0h';
    }
  }
}
